export const DISPLAY_FONT_STACK = `var(--estimate-layout-font-display, 'Barlow Condensed', 'Arial Narrow', sans-serif)`;

export const SCRIPT_FONT_STACK = `var(--estimate-layout-font-script, 'Dancing Script', cursive)`;

export const BODY_FONT_STACK = `var(--estimate-layout-font-body, 'Lato', sans-serif)`;

export const FONT_ALIASES: Record<string, string> = {
    'barlow condensed': DISPLAY_FONT_STACK,
    'dancing script': SCRIPT_FONT_STACK,
};

export const PRINT_FONT_FACES = [
    '400 1em "Lato"',
    '700 1em "Lato"',
    '600 1em "Barlow Condensed"',
    '700 1em "Barlow Condensed"',
    '400 1em "Dancing Script"',
];

export function resolveFontFamily(declared: string): string {
    const first = declared.split(',')[0].trim().replace(/^['"]|['"]$/g, '').toLowerCase();

    return FONT_ALIASES[first] ?? declared;
}
